<template>
  <b-modal v-model="active" :title="title" centered hide-footer size="md">
    <div class="mt-3 px-4">
      <b-row v-for="(user, index) in assignedUsersObject" :key="index" class="mb-2 align-items-center">
        <b-col cols="2"></b-col>
        <b-col cols="2">
          <h-e-profile-default
            :first-name="user.first_name"
            :last-name="user.last_name"
            size="sm"
          ></h-e-profile-default>
        </b-col>
        <b-col cols="8">
          <div class="ml-5">{{ user.first_name }} {{ user.last_name }}</div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'user-visualizer-v2',

  props: {
    title: {
      type: String,
      required: true,
    },
    assignedUsersObject: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      active: false,
    }
  },

  methods: {
    manageUserPop() {
      this.active = !this.active
    },
  },
}
</script>

<style scoped></style>
